import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CompaniesService } from 'src/app/settings/services/companies.service';
import { ContextualMenuService } from 'src/app/settings/services/contextual-menu.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import constants from 'src/app/shared/constants';

@Component({
  selector: 'app-company-edit-settings',
  templateUrl: './company-edit-settings.component.html',
  styleUrls: ['./company-edit-settings.component.scss'],
})
export class CompanyEditSettingsComponent {
  featureFlags = constants.featureFlags;
  showConfigs = false;

  constructor(
    public dialog: MatDialog,
    public authService: AuthService,
    public companiesService: CompaniesService,
    public contextualMenuService: ContextualMenuService
  ) {}

  onKaironIsEnabledChange(company: any, newValue: boolean) {
    if (company.kairon?.isEnabled !== newValue) {
      company.kairon.isEnabled = newValue;
    }
  }

  onRadiusMetersChange(company: any, newValue: number) {
    if (company.kairon?.eventDetectionConfig?.radiusMeters !== newValue) {
      company.kairon.eventDetectionConfig.radiusMeters = newValue;
    }
  }

  onToleranceMinutesChange(company: any, newValue: number) {
    if (company.kairon?.reminderConfig?.toleranceMinutes !== newValue) {
      company.kairon.reminderConfig.toleranceMinutes = newValue;
    }
  }

  onRetryMinutesChange(company: any, newValue: number) {
    if (company.kairon?.reminderConfig?.retryMinutes !== newValue) {
      company.kairon.reminderConfig.retryMinutes = newValue;
    }
  }

  onCidInput(e: Event) {
    const el = e.target as HTMLInputElement;
    let v = (el.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (v.length > 5) v = v.slice(0, 5);

    el.value = v;
    this.companiesService.currentCompany.kairon.eventDetectionConfig.eventCID = v;
  }

  onLowControlChange(receiver: any, newValue: number) {
    if (receiver.testPHourConfiguration?.lowControl !== newValue) {
      receiver.testPHourConfiguration.lowControl = newValue;
    }
  }

  onGoodControlChange(receiver: any, newValue: number) {
    if (receiver.testPHourConfiguration?.goodControl !== newValue) {
      receiver.testPHourConfiguration.goodControl = newValue;
    }
  }

  testPHourConfigurationLowControlError(testPHourConfiguration: any) {
    return testPHourConfiguration.lowControl >= testPHourConfiguration.goodControl;
  }

  testPHourConfigurationGoodControlError(testPHourConfiguration: any) {
    return testPHourConfiguration.goodControl <= testPHourConfiguration.lowControl;
  }

  onMaiaIsEnabledChange(company: any, newValue: boolean) {
    if (company.maia?.isEnabled !== newValue) {
      company.maia.isEnabled = newValue;
    }
  }

  onAlarmEventSendChange(company: any, key: string, newValue: string) {
    if (company.maia?.perimetralConfig?.[key] !== newValue) {
      company.maia.perimetralConfig[key] = newValue;
    }
  }

  isMaiaEnabled(company: any) {
    return this.authService.isFeatureFlagEnabled(constants.featureFlags.iaMaia, company._id);
  }
}
